// contexts/UserContext.jsx
import { createContext, useContext, useState, useEffect } from 'react';
import apiRequest from '@/services/requests';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const UserContext = createContext();

export const UserProvider = ({ children,skipFetch = false }) => {
const [user, setUser] = useState(null); // profile + language
const [loading, setLoading] = useState(!skipFetch);

useEffect(() => {
if (skipFetch) return; 

(async () => {
try {
const profile = await apiRequest.getProfile();
setUser(profile);
// language from profile or localStorage fallback
const lang = profile.language || localStorage.getItem('currentLanguage') || 'en';
localStorage.setItem('currentLanguage', lang);
} catch (e) {
// console.error(e);
toast.error('--An error occured. Please refresh the page or try again later!', {
position: 'bottom-left'
});
} finally {
setLoading(false);
}
})();
}, [skipFetch]);

return (
<UserContext.Provider value={{ user, setUser, loading }}>
{children}
</UserContext.Provider>
);
};

export const useUser = () => useContext(UserContext);